// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ionq","top":"styles_top__3aYTa","left":"styles_left__2Jv6U","description":"styles_description__3oVMP"};